// @flow

import { useCallback } from 'react';

export type SodexoUserInputValues = {
  userChileanRut: string,
};

export type SodexoUserInputValuesKey = $Keys<SodexoUserInputValues>;

export type SodexoUserInputValuesStateUpdater =
  (SodexoUserInputValues | (SodexoUserInputValues) => SodexoUserInputValues) => void;

export function useSodexoUserInputValueChangeHandler(setUserInputValues: SodexoUserInputValuesStateUpdater): UserInputValueChangeHandler {
  const handler = useCallback((key: SodexoUserInputValuesKey) => (evt: SyntheticInputEvent<HTMLInputElement>) => {
    const value = evt.currentTarget.value;

    setUserInputValues((current: SodexoUserInputValues) => ({
      ...current,
      [(key: string)]: value,
    }));
  }, [setUserInputValues]);

  return handler;
}

type UserInputValueChangeHandler =
  (key: SodexoUserInputValuesKey) => (evt: SyntheticInputEvent<HTMLInputElement>) => void
  ;
